import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Button, Container, Grid, makeStyles, Typography, TextField } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    btn: {
      marginTop: '41px',
      width: '40%',
    },
    container: {
      maxWidth: '500px',
      padding: '26px',
    },
    field: {
      marginTop: '8px',
      width: '100%',
    },
    formTitle: {
      color: '#172B4D',
      fontWeight: 'bold',
      marginBottom: '4px',
    },
    message: {
      color: '#999999',
      fontSize: '14px !important',
      lineHeight: '22px',
      marginBottom: '0px',
    },
  };
});
export default ({ onCancel, onConfirm, name, isUpdate, code }) => {
  const classes = useStyles();
  const [currentName, setCurrentName] = useState('');
  const [currentCode, setCurrentCode] = useState('');

  const handleConfirm = () => {
    if (!onConfirm || typeof onConfirm !== 'function') return;
    onConfirm({ code: currentCode, name: currentName });
  };

  const handleNameChange = useCallback((e) => {
    setCurrentName(e.target.value);
  }, []);

  const handleCodeChange = useCallback((e) => {
    setCurrentCode(e.target.value);
  }, []);

  useEffect(() => {
    setCurrentName(name);
  }, [name]);

  useEffect(() => {
    setCurrentCode(code);
  }, [code]);

  const isAddDisabled = useMemo(() => {
    return !currentName || !currentCode;
  }, [currentName, currentCode]);

  const descriptionText = useMemo(() => {
    return isUpdate ? 'Update discount name and discount coupon code.' : 'Enter a new discount name and discount coupon code.';
  }, [isUpdate]);

  return (
    <Container disableGutters className={classes.container}>
      <Grid container className="text-left-">
        <Grid item xs={12} className="text-left">
          <Typography className={`${classes.formTitle}`}>{isUpdate ? 'Edit' : 'Add'} Discount</Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1" className={`body-copy ${classes.message}`}>
            {descriptionText}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField onChange={handleNameChange} placeholder="Enter discount name" type="text" variant="standard" className={classes.field} value={currentName} label="Name" />

          <div style={{ marginTop: '8px' }}>
            <TextField
              onChange={handleCodeChange}
              placeholder="Enter coupon code"
              type="text"
              variant="standard"
              className={classes.field}
              value={currentCode}
              label="Coupon Code"
            />
          </div>
        </Grid>

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={4} style={{ paddingRight: '6px' }}>
              <Button variant="link" style={{ width: '100%' }} fullWidth size="medium" color="primary" onClick={onCancel} className={classes.btn}>
                Cancel
              </Button>
            </Grid>
            <Grid item xs={8} style={{ paddingLeft: '6px' }}>
              <Button
                variant="contained"
                style={{ width: '100%' }}
                fullWidth
                size="medium"
                color="primary"
                onClick={handleConfirm}
                className={classes.btn}
                disabled={isAddDisabled}>
                {isUpdate ? 'Update' : 'Add'} Discount
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};
